if (!customElements.get('simple-faq-group')) {
  customElements.define(
    'simple-faq-group',
    class SimpleFaqGroup extends HTMLElement {
      constructor() {
        super();
        this.details = this.querySelectorAll('details');
        this.summaries = this.querySelectorAll('summary');
      }

      connectedCallback() {
        // Add toggle event listeners to handle accordion behavior
        this.details.forEach((detail) => {
          detail.addEventListener('toggle', this.handleToggle.bind(this));
        });

        // Add click listeners directly to summaries and their children
        this.summaries.forEach((summary) => {
          // Ensure clicks on any child element trigger the toggle
          summary.addEventListener('click', this.handleSummaryClick.bind(this));

          // Make sure text content is clickable too
          const textContainer = summary.querySelector('div span');
          if (textContainer) {
            textContainer.addEventListener('click', (event) => {
              // Prevent default to avoid potential conflicts
              event.preventDefault();
              // Manually toggle the parent details element
              const details = summary.closest('details');
              if (details) {
                details.open = !details.open;
              }
            });
          }
        });
      }

      handleSummaryClick(event) {
        // The native toggle behavior will still work
        // This just ensures proper event handling
        event.stopPropagation();
      }

      handleToggle(event) {
        if (event.target.open) {
          this.details.forEach((detail) => {
            if (detail !== event.target && detail.open) {
              detail.open = false;
            }
          });
        }
      }
    }
  );
}
